import { pagenation } from './pagenation';
import { releaseItem } from './releaseItem';

export function release() {
  const releaseList = document.querySelector('#releaseList');

  if(releaseList) {
    //現在のURLを取得
    const localurl = new URL(window.location.href);
    //URLパラメーターを取得
    const searchParams = localurl.searchParams;
    //API取得に必要なパラメーターを取得
    const params = {
      category: searchParams.get('category') || null,
      year: searchParams.get('year') || '直近1年',
      page: searchParams.get('page') || 1,
    }
    //APIのURL
    const apiurl = 'https://secure02.red.shared-server.net/www.o-tec.co.jp/cron_marge/release.php';

    //カテゴリーボタンの設定
    const setCategory = (params) => {
      const category = params.category || 'all';
      const year = params.year !== '直近1年' ? params.year : null;

      //カテゴリーボタンを取得
      const categoryBtns = document.querySelectorAll('.js-releaseCateBtn');
      categoryBtns.forEach(categoryBtn => {
        const categoryId = categoryBtn.dataset.id;

        //現在のカテゴリーにis-activeクラスを付与
        if(categoryId === category) {
          categoryBtn.classList.add('is-active');
        }
        
        //クリックした時の遷移先を設定
        let url = categoryId !== 'all'? `/release/?category=${categoryId}` : '/release/';
        if(year) {
          url += `${url.includes('?') ? '&' : '?'}year=${year}`;
        }

        categoryBtn.addEventListener('click', () => {
          window.location.href = url;
        });
      });
    }

    //年代セレクトボックスの設定
    const setSelectbox = (years) => {
      const yearList = document.querySelector('#yearList');
      const selectYear = document.querySelector('.js-releaseSelect--panel');
      selectYear.textContent = params.year;

      //現在のページと値が一致する場合
      if(params.year !== '直近1年') {
        const activeYear = yearList.querySelector('.is-active');
        activeYear.classList.remove('is-active');
      }

      years.forEach(year => {
        const yaerTxt = year + '年';
        const newElement = document.createElement('span');
        newElement.classList.add('c-selectType01_optionItem', 'js-select01--option', 'js-releaseSelect--trigger');
        if(params.year === yaerTxt) {
          newElement.classList.add('is-active');
        }
        newElement.dataset.value = yaerTxt;
        newElement.textContent = yaerTxt;
        yearList.appendChild(newElement);
      });
    }

    //年代を選択する
    const selectedYear = () => {
      const triggers = document.querySelectorAll('.js-releaseSelect--trigger');
      triggers.forEach(trigger => {
        const year = trigger.dataset.value;
        let url = params.category ? `?category=${params.category}` : '/release/';
        if(year !== '直近1年') {
          url += `${url.includes('?') ? '&' : '?'}year=${year}`;
        }
        trigger.addEventListener('click', () => {
          window.location.href = url;
        });
      });
    }

    //エラー処理
    const error = () => {
      const errorElement = document.querySelector('.js-error');
      errorElement.classList.add('is-view');
    }

    const setReleaseList = (posts) => {
      posts.forEach(post => {
        let newElement = releaseItem(post);
        releaseList.appendChild(newElement);
      });
    }

    //APIで取得した情報でページを作成する
    const setRelease = (result) => {
      const res = result.res;
      const data = result.data;
      const max_page = result.max_page;
      const year_range = result.year_range;

      setSelectbox(year_range);

      if(res) {
        //表示できる情報を取得できた場合
        setReleaseList(data);
        pagenation(max_page);
      } else {
        //表示できる情報を取得できなかった場合
        error();
      }
    }

    const getReleaseApi = (params, url) => {
      fetch(url, {
        method : "POST",
        headers: {
          'Content-Type': 'application/json' // JSON形式のデータのヘッダー
        },
        body: JSON.stringify(params)
      })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        setRelease(result);
      })
      .then(() => {
        selectedYear();
      })
      .catch((e) => {
        console.log(e);   
      });
    }

    if(releaseList) {
      
    }
    setCategory(params);
    getReleaseApi(params, apiurl);
  }
}